const SITE_URL: string =
  import.meta.env.VITE_SITE_URL || "https://hipobuyspread.online";

const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg";

export function getWebsiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Hipobuy Spreadsheet Guide",
    url: SITE_URL,
    description:
      "The ultimate Hipobuy Spreadsheet resource center for product research, shopping guides, QC tips, and expert strategies.",
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
}

export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Hipobuy Spreadsheet Guide",
    url: SITE_URL,
    logo: FAVICON_URL,
    description:
      "Independent resource hub for online shopping research, product spreadsheets, and comparison guides.",
    sameAs: ["https://kaspreadsheet.com"],
  };
}

export function getArticleSchema(params: {
  headline: string;
  description: string;
  url: string;
  imageUrl?: string;
  datePublished?: string;
  dateModified?: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: params.headline,
    description: params.description,
    url: params.url,
    ...(params.imageUrl ? { image: params.imageUrl } : {}),
    author: {
      "@type": "Organization",
      name: "Hipobuy Spreadsheet Guide",
      url: SITE_URL,
    },
    publisher: {
      "@type": "Organization",
      name: "Hipobuy Spreadsheet Guide",
      logo: { "@type": "ImageObject", url: FAVICON_URL },
    },
    datePublished: params.datePublished || "2026-07-11",
    dateModified: params.dateModified || "2026-07-11",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": params.url,
    },
  };
}

export function getFAQPageSchema(faqs: Array<{ question: string; answer: string }>) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };
}

export function getBreadcrumbSchema(items: Array<{ name: string; url: string }>) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export { SITE_URL, FAVICON_URL };